<template>
  <div class="uploadprocess">
    <div v-if="isOver === 0">
      <p style="color:#FF8C05;font-size:5.6vw">{{progress}}%</p>
      <div class="container">
        <div :style="{width : progress + '%',opacity: progress === 0 ? '0': '1'}"
             class="warning">
        </div>
        <div class="bj">

        </div>
      </div>
      <!-- <van-progress color="#FF8C05" stroke-width="16" :percentage="progress" /> -->
      <p>请勿关闭此页面，耐心等待哦~</p>
    </div>
    <div v-if="isOver === 1">
      <img width="350vw"
           src="@/assets/uploader/picsuccess.png"
           alt="">
      <van-button @click="goback"
                  class="btn"
                  round
                  type="info">返回</van-button>
    </div>
    <div v-if="isOver === 2">
      <img width="350vw"
           src="@/assets/uploader/picerror.png"
           alt="">
      <van-button @click="goback"
                  class="btn"
                  round
                  type="info">返回</van-button>
    </div>
  </div>
</template>

<script>
import getMD5 from "@/plugins/getMD5";
import { mapGetters, mapActions } from 'vuex'
import {
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import { addPicture } from "@/api/picture";

import {
  addPicturePackage
} from "@/api/picturePackage";
import Vue from 'vue'
import { Notify, Toast } from 'vant';
Vue.use(Toast);
export default {
  data () {
    return {
      fileList: this.$store.state.user.fileList,
      kuai: '',
      progress: 0,
      isOver: 0,
      repeatCount: 0,
      mergeRepeatCount: 0,
      failcount: 0,
      successCount: 0,


      ids:[]
    }
  },
  computed: {
    ...mapGetters(["createUid"])
  },
  methods: {
    ...mapActions(["setFileList"]),
    goback () {
      if (localStorage.getItem('isQcode') == 'true') {
        this.$router.push('/public/mobileUpdate')
      } else {
        this.$router.push('/pictureCenterMobile')
      }
    },
    upload () {
      this.kuai = Math.ceil(100 / this.fileList.length)
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].file.size > 2 * 1024 * 1024) {
          bytesPerPiece = 500 * 1024;
        } else {
          bytesPerPiece = 100 * 1024;
        }

        getMD5(this.fileList[i].file, md5 => {
          fileMD5 = md5;
          this.getFileInfoByHashAsync(
            fileMD5,
            this.fileList[i].file,
            bytesPerPiece,
            totalPieces,
            i
          );
        });
      }
    },

    //图片上传成功之后，创建图片对象
    afterUploadAdd (id) {
      if (id !== 0) {
        let desc = ""
        if (this.$route.query.atlasDesc == "") {
          desc = this.$route.query.atlasName
        } else {
          desc = this.$route.query.atlasName + " - " + this.$route.query.atlasDesc
        }
        let picMsg
        picMsg = {
          atlasId: this.$store.state.user.atlasId,
          fileId: id,
          libId: this.$store.state.user.libId,
          desc: desc,
          createUid: this.createUid,
          tags: ''
        };
        if (this.$route.query.isOnly) {
          picMsg = {
            atlasId: '0',
            fileId: id,
            libId: '0',
            desc: "",
            createUid: this.createUid,
            tags: ''
          };
        }
        this.addPictureAsync(picMsg);
      } else {
        this.addPictureAsync(0);
      }
    },


    //分片上传
    async fragmentation (val, blob, bytesPerPiece, totalPieces, i) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;

      let fileProgress = 0

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        fileProgress = parseFloat((this.kuai / totalPieces).toFixed(2))
        if (index < totalPieces) {
          // console.log('分片次数',index)
          await this.uploadPicChunkAsync(params, formData, blob, fileProgress);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并  ' + index)
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          await this.uploadPicChunkMergeAsync(params, blob, i);
        }
        start = end;
        index++;
        this.progress = parseFloat(this.progress.toFixed(2))
      }
    },




    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, i) {
      let { status, data, message } = await getFileInfoByHash(val);
      console.log(i + "----" + blob.name);
      // return
      if (status) {
        this.afterUploadAdd(data.id);
        this.progress += this.kuai
        if (this.progress >= 100) {
          this.progress = 99.99
        }
      } else {
        this.fragmentation(val, blob, b, t, i);
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob, fp) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        this.failcount++;
      } else {
        // console.log("分片第一步");
        // this.progress += fp
        // if (this.progress >= 100) {
        //   this.progress = 99.99
        // }
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, i) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (status) {
        this.afterUploadAdd(data.id);
      } else {
        console.log(i);
        this.failcount++;
        if (message == '文件已存在，请勿重复上传。') {
          Notify({ type: 'warning', message: "有一张图片重复，已将此图片删除！" });
        } else {
          Toast(message)
          this.isOver = 2
        }
      }
    },

    //创建图片对象
    async addPictureAsync (val) {
      let { status, data, message } = await addPicture(val);
      if (status) {
        this.successCount++;
        // if (this.progress >= 99.99) {
        //   this.progress = 99.99
        // }
        this.ids.push(data.id)
        if (this.progress + this.kuai >= 100) {
          this.progress = 99.99
        } else {
          this.progress += this.kuai
          this.progress = parseFloat(this.progress.toFixed(2))
        }

      } else {
        if (this.repeatCount >= 5) {
          this.failcount++;
          this.repeatCount = 0
        } else {
          this.repeatCount++;
          this.addPictureAsync(val);
        }
      }
      console.log(this.fileList.length, this.successCount, this.failcount);
      if (this.successCount + this.failcount >= this.fileList.length) {
        if(localStorage.getItem('live')){
          let val = {
            createUid: this.createUid,
            packageType: "push",
            pictureCount: this.ids.length,
            pictureIds: this.ids.join(','),
            targetUid: 0,
            title: '移动端推送到图片直播',
            pushConfig: localStorage.getItem('live')
          }
          this.addPicturePackageAsync(val);
        }
        this.isOver = 1
        if (this.failcount > 0) {
          Toast("上传成功，但有" + this.failcount + "张图片上传失败！")
        } else {
          this.progress = 100
        }
        this.setFileList(null)
        this.successCount = 0
        this.failcount = 0
      }
    },

    async addPicturePackageAsync (val) {
      let {
        status,
        data,
        message,
        errors
      } = await addPicturePackage(val);
      if (status) {
        localStorage.removeItem('live')
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        Notify({
          type: 'danger',
          message: {
            message: message + errortext
          }
        })
      }
    },

    //base64转blob
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //blob转file
    blobToFile (newBlob, fileName) {
      newBlob.lastModifiedDate = new Date();
      newBlob.name = fileName;
      return newBlob;
    },
  },
  created () {
    console.log('用户id', this.createUid);

    if (!this.fileList) {
      this.fileList = JSON.parse(sessionStorage.getItem('fileList'))
      for (let i = 0; i < this.fileList.length; i++) {
        this.fileList[i].file = this.blobToFile(this.dataURLtoBlob(this.fileList[i].baseFile), this.fileList[i].name)
      }
    }

    setTimeout(() => {
      this.upload()
    }, 200);
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
@import "./uploadprocess.scss";
</style>